import clipboard from 'clipboard';
import { Toast } from 'vant';
export default {
  name: 'ClipboardBtn',
  props: {
    value: {
      type: String,
      default: null
    }
  },
  mounted() {
    const self = this;
    self.$nextTick(() => {
      const clipboardInstance = new clipboard(self.$el);
      clipboardInstance.on('success', function (e) {
        Toast('复制成功');
        e.clearSelection();
      });
      clipboardInstance.on('error', function (e) {
        Toast('复制失败');
      });
    });
  }
};